import Schema from '../Schema';

import { SALES_METHOD, SALES_METHOD_PATTERN } from '../../constants/shop';

const SearchProducts = new Schema({
  _id: String,
  // 商品タイトル
  title: {
    type: String,
    default: ''
  },
  // 商品詳細URL Products.detailUrl()
  url: {
    type: String,
    default: ''
  },
  // 商品メイン画像
  main_image: {
    type: Object,
    default: {}
  },
  images: {
    type: Array,
    default: []
  },

  // SKU IDの配列
  skus: {
    type: Array,
    default: []
  },
  // 商品カテゴリ
  category: {
    type: Array,
    default: []
  },

  // Sales method
  sales_method: {
    type: String,
    enum: SALES_METHOD_PATTERN,
    default: SALES_METHOD.NORMAL
  },

  // Prices
  prices: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    },
    min_sale: {
      type: Number,
      default: 0
    },
    max_sale: {
      type: Number,
      default: 0
    },
    min_selling: {
      type: Number,
      default: 0
    },
    max_selling: {
      type: Number,
      default: 0
    },
    discounted: {
      type: Number,
      default: 0
    },
    discount_rate: {
      type: Number,
      default: 0
    }
  },

  // 持っているSKUの割引率が異なるSKUがあるかどうか
  has_different_discount_rate: {
    type: Boolean,
    default: false
  },

  // TOM Points
  points: {
    min: Number,
    max: Number,
    percentage: Number
  },

  // 新着商品かどうか
  new_arrival: {
    type: Boolean,
    default: false
  },
  // 売り切れかどうか
  is_out_of_stock: {
    type: Boolean,
    default: false
  },
  // 廃盤商品かどうか
  is_discontinued: {
    type: Boolean,
    default: false
  },
  // デジタルコンテンツかどうか
  is_digital_content: {
    type: Boolean,
    default: false
  },
  // シリアルコードSKUかどうか
  is_serial_code: {
    type: Boolean,
    default: false
  },
  // Free shippingかどうか
  is_free_shipping: {
    type: Boolean,
    default: false
  },
  // TOM専売商品 Exclusive かどうか
  is_exclusive_product: {
    type: Boolean,
    default: false
  },
  // SKU に TOM Premium 会員限定価格を持っているかどうか
  has_premium_price: {
    type: Boolean,
    default: false
  },
  // レビュー情報
  review_stats: {
    // 平均評価
    average_stars: {
      type: Number,
      default: 0
    },
    // レビュー数
    count: {
      type: Number,
      default: 0
    }
  },
  // SKU が Favorite(Wish list) に追加されているかどうか
  is_added_to_wishlist: {
    type: Boolean,
    default: false
  },
  // ポイント交換対象のSKUを含むかどうか
  is_points_redemption: {
    type: Boolean,
    default: false
  }
});

export default SearchProducts;
